module.exports = __webpack_public_path__ + "static/media/snapshot-sample3.569f44cc.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/img/ittybittyapps/snapshot-sample3.mp4
// module id = 73
// module chunks = 0